<template>
  <div class="barcode-modal-wrap">
    <div id="barcode-content">
      <lk-modal v-model="showModal"
        :closable='false'
        :mask-closable='false'
        width="400"
        title="订单号二维码"
      >
        <div class="barcode-txt">
          <span>请通过浦发pos"邻客智慧药房收款"功能，扫描以下二维码进行收款，收款后对应金额会自动计入"浦发pos收款"收款方式</span>
        </div>
        <div id="printSection" v-if="showModal && barcodeData.orderNo">
          <vue-qr :text='barcodeData.orderNo' :callback="qrCallback" :size="200"></vue-qr>
          <span class="orderNo-txt">{{barcodeData.orderNo}}</span>
        </div>
        <div slot='footer'>
          <lk-button @click='handlerPrint'>
            打印二维码
          </lk-button>
          <lk-button @click="handlerCancel">关闭</lk-button>
        </div>
      </lk-modal>
    </div>
    <POSModal
      v-model="showDTPModal"
      :content="config.content"
      :content_title="config.content_title"
      @handleCancel='handlePOSCancel'
      :type="config.type"
      :noCancel='config.noCancel'
      :showCountDown='config.showCountDown'
      @confirm='showDTPModal=false'
      ref="posModal"
    ></POSModal>
  </div>
</template>
<script>
import _ from 'lodash';
import VueQr from 'vue-qr';
import POSModal from './POSModal.vue';
import sale from '../services/sale';
import utils from '../libs/utils';

export default {
  name: 'BarcodeModal',
  props: {
    barcodeData: {
      type: Object,
    },
    showModal: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    POSModal,
    VueQr,
  },
  model: {
    prop: 'showModal',
    event: 'change',
  },
  data() {
    return {
      showDTPModal: false,
      config: {
        content: '未完成收款的店销销售订单会影响新订单创建，您可以在销售订单列表中再次查看订单二维码',
        content_title: '您还没有完成收款，是否确认关闭?',
        type: 'alert', // 提示类型
        noCancel: false, // 取消按钮
        showCountDown: false, // 倒计时
      },
      time: '',
      orderType: '', // 1 表示店销，2是配送
    };
  },
  watch: {
  },
  methods: {
    qrCallback() {
      this.pollingOrderInfo();
    },
    handlerPrint: _.debounce(function a() {
      const copy = document.querySelector('#printSection');
      this.$print(copy);
    }, 1000),
    handlePOSCancel() {
      this.$emit('change', true);
    },
    handlerCancel() {
      this.$emit('change', false);
      this.clearTime();
      this.resetConfig();
      // 两种情况，1：店销订单未收款完成，2:配送订单未收款完成
      if (this.orderType == 1) {
        this.config.content = '未完成收款的店销销售订单会影响新订单创建，您可以在销售订单列表中再次查看订单二维码';
      }
      if (this.orderType == 2) {
        this.config.content = '该配送销售订单只能在完成收款后确认签收，您可以在销售订单列表中再次查看订单二维码';
      }
      this.showDTPModal = true;
    },
    resetConfig() {
      this.config = {
        content: '未完成收款的店销销售订单会影响新订单创建，您可以在销售订单列表中再次查看订单二维码',
        content_title: '您还没有完成收款，是否确认关闭?',
        type: 'alert', // 提示类型
        noCancel: false, // 取消按钮
        showCountDown: false, // 倒计时
      };
    },
    getOrderInfo(id) {
      this.$store.commit('setDisableLoading', true);
      sale.getOrderAllById({ id }).then((res) => {
        if (res.data.status === 200) {
          const {
            type, // type =1 表示店销，2是配送
            tag, // 0—— 表示正常订单， 1 —— 表示顺丰代收订单， 2 -——表示浦发收款订单
            proceedsStatus, // 1收款完成
            receivablesAmount, // pos收款金额
          } = res.data.data.saleOrder;
          this.orderType = type;
          if (proceedsStatus === 1 && tag === 2) {
            this.config.content_title = `收款完成,浦发pos收款: ${receivablesAmount || 0}`;
            this.config.content = '';
            this.config.type = 'success';
            this.config.noCancel = true;
            this.config.showCountDown = true;
            this.$emit('change', false);
            this.showDTPModal = true;
            this.$refs.posModal.countDown();
            this.clearTime();
            this.$emit('success');
          }
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    pollingOrderInfo() {
      let func;
      this.time = setInterval((func = () => {
        this.getOrderInfo(this.barcodeData.id);
        return func;
      })(), 5000);
    },
    clearTime() {
      if (this.time) {
        clearInterval(this.time);
      }
    },
  },
  mounted() {
  },
  created() {},
};
</script>
<style lang="less" scoped>
 /deep/.ivu-modal-header {
    border-bottom: none;
    padding-bottom: 0px;
    padding-left: 24px;
  }
  /deep/ .ivu-modal-footer {
    border-top: none;
    padding-top: 0px;
  }
  .barcode-txt {
    padding-left: 8px;
    font-size: 13px;
  }
  #printSection {
    display: flex;
    flex-direction: column;
    align-items: center;
    .orderNo-txt {
      font-size: 14px;
      font-weight: 500;
    }
  }
</style>
